import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { useKeycloak } from "@react-keycloak/web/lib/useKeycloak";
import { TUserInfo } from "../../@types/user-info.type";
import Avatar from "@mui/material/Avatar/Avatar";
import { stringAvatar } from "../../utils/avatar";
import avatar from "./../../assets/pexels-pixabay-262391.png";
import arrowDropdown from "./../../assets/Polygon.svg";
import { useNavigate } from "react-router-dom";

export const Profile = () => {
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);
  const [userInfo, setUserInfo] = useState<TUserInfo>({} as TUserInfo);
  const { keycloak } = useKeycloak();
  const navigate = useNavigate();

  const loadUserInfo = async () => {
      const user = await keycloak.loadUserInfo() as TUserInfo
      setUserInfo(user);
    };
  
    useEffect(() => {
      loadUserInfo();
    }, [keycloak]);
  
  return (
    <>
      <div
        className={`${styles.profile} ${isOpenDropdown && styles.open} `}
        onClick={() => setIsOpenDropdown(!isOpenDropdown)}
      >
        <div className={styles.profileHeader}>
          {userInfo && userInfo.name ? <Avatar
            style={{ margin: "5px", opacity: "0.5", float: "left" }}
            {...stringAvatar(userInfo.name)}
          /> : <img src={avatar} alt="" className={styles.profileAvatar} />
          }
          <div className={styles.profileInfoAndBtn}>
            <div className={styles.profileInfo}>
              {userInfo && <p>{userInfo.name}</p>}
             
            </div>
          </div>
          <div>
            <button>
              <img src={arrowDropdown} alt="" />
            </button>
          </div>
        </div>
         <div className={`${styles.profileDropdown}`}>
          <ul>
            <li>
              <button onClick={() => {
                keycloak.logout();
              }}>Sair</button>
            </li>
          </ul>
        </div> 
      </div>

    </>
  );
};
